module.exports = __webpack_public_path__ + "img/forest_grey_al.33866af2.svg";